import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieBanner.css';

const COOKIE_KEY = "ta_cookies_accepted";

const CookieIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <circle cx="8" cy="9" r="1" fill="currentColor"/>
    <circle cx="15" cy="8" r="1" fill="currentColor"/>
    <circle cx="10" cy="14" r="1" fill="currentColor"/>
    <circle cx="16" cy="13" r="1" fill="currentColor"/>
    <circle cx="12" cy="17" r="1" fill="currentColor"/>
  </svg>
);

const XIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Mostrar banner solo si no se ha aceptado antes
    const accepted = localStorage.getItem(COOKIE_KEY);
    if (!accepted) {
      // Pequeño delay para que no aparezca inmediatamente
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, JSON.stringify({ 
      accepted: true, 
      date: new Date().toISOString(),
      type: 'all'
    }));
    setVisible(false);
  };

  const handleTechnicalOnly = () => {
    localStorage.setItem(COOKIE_KEY, JSON.stringify({ 
      accepted: true, 
      date: new Date().toISOString(),
      type: 'technical'
    }));
    setVisible(false);
  };

  const handleClose = () => {
    // Cerrar sin guardar preferencia (volverá a aparecer)
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" data-testid="cookie-banner">
      <div className="cookie-banner-content">
        <div className="cookie-icon">
          <CookieIcon />
        </div>
        
        <div className="cookie-text">
          <h3>Usamos cookies técnicas</h3>
          <p>
            Utilizamos únicamente cookies técnicas necesarias para el funcionamiento de la herramienta. 
            No compartimos datos con terceros ni usamos cookies de seguimiento. Tu privacidad es nuestra prioridad.
          </p>
        </div>

        <button className="cookie-close" onClick={handleClose} aria-label="Cerrar">
          <XIcon />
        </button>
      </div>

      <div className="cookie-actions">
        <button className="cookie-btn cookie-btn-primary" onClick={handleAccept} data-testid="cookie-accept">
          Aceptar
        </button>
        <button className="cookie-btn cookie-btn-secondary" onClick={handleTechnicalOnly} data-testid="cookie-technical">
          Solo técnicas
        </button>
        <Link to="/politica-cookies" className="cookie-link">
          Más info
        </Link>
      </div>
    </div>
  );
}
